import { Routes } from '@angular/router';
import { HomeViewComponent } from './views/home-view/home-view.component';
import { ARSViewComponent } from './views/ars-view/ars-view.component';
import { LimitiViewComponent } from './views/limiti-view/limiti-view.component';
import { FlussiViewComponent } from './views/flussi-view/flussi-view.component';
import { environment } from '@environments/environment';

let contextRoot = '';
if (environment.contextRoot !== '') {
	contextRoot = environment.contextRoot.replace('/', '') + '/';
}
export const routes: Routes = [
	{ path: `${contextRoot.replace('/', '')}`, component: HomeViewComponent, title: 'Portale Viabilità' },
	{ path: `${contextRoot}ars`, component: ARSViewComponent, title: 'Portale Viabilità - ARS Online' },
	{ path: `${contextRoot}limiti`, component: LimitiViewComponent, title: 'Portale Viabilità - Limiti Online' },
	{ path: `${contextRoot}flussi`, component: FlussiViewComponent, title: 'Portale Viabilità - Flussi Online' },
	{ path: `${contextRoot}**`, redirectTo: `${contextRoot}`, title: 'Portale Viabilità' },
];
